
import React from 'react';
import { Plus } from 'lucide-react';

interface PhotoUploadButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const PhotoUploadButton: React.FC<PhotoUploadButtonProps> = ({
  onClick,
  disabled = false
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`w-full aspect-square flex flex-col items-center justify-center border-2 border-dashed rounded-lg transition-colors ${
        disabled
          ? 'border-white/20 bg-black/20 cursor-not-allowed' 
          : 'border-white/30 bg-black/30 hover:bg-black/50 hover:border-white/50'
      }`}
    >
      <Plus className="h-6 w-6 sm:h-8 sm:w-8 mb-1 sm:mb-2 text-white/70" />
      <span className="text-xs sm:text-sm text-white/70">Adicionar</span>
    </button>
  );
};

export default PhotoUploadButton;
